export default __webpack_public_path__ + "static/media/ydyx.b54996bc.jpg";